// 郵便番号住所検索ポップアップ
import React from 'react';
import { Modal } from 'react-bootstrap';
import Heading from './Heading';

interface Props {
  toggleShow: boolean;
  toggleClose: React.MouseEventHandler;
  popupClick: (address_info: { id: string; address: string; kana_address: string }) => void;
  address_list: AddressInfo[];
}

interface AddressInfo {
  address: string;
  kana_address: string;
}

const SearchAddress: React.FC<Props> = ({ toggleShow, toggleClose, popupClick, address_list }) => {
  return (
    <Modal
      size="lg"
      show={toggleShow}
      onHide={toggleClose}
      animation={false}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Heading label={'郵便番号住所検索'} size={'m'} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Heading label="住所一覧" size={'s'} />
        <table className="modal-table">
          <tbody>
            <tr>
              {Object.values(address_list).map((value: any, index: number) => {
                return (
                  <td onClick={() => popupClick(value)} key={index}>
                    {value.address}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};

export default SearchAddress;
